import { useEffect } from "react";

import { teliaTheme } from "./telia-theme";
import type { ColorScheme, Theme } from "./types";

const toKebabCase = (str: string) => str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

type Props = {
  theme?: Theme;
  cssVariablesSelector?: string;
  currentColorScheme?: ColorScheme;
};

export const useApplyTheme = ({
  theme = teliaTheme,
  cssVariablesSelector,
  currentColorScheme,
}: Props) => {
  useEffect(() => {
    if (currentColorScheme) {
      Object.entries(theme?.[currentColorScheme] ?? teliaTheme[currentColorScheme]).forEach(
        ([key, value]) => {
          const element = cssVariablesSelector
            ? (document.querySelector(cssVariablesSelector) as HTMLElement)
            : null;

          (element ?? document.documentElement).style.setProperty(
            `--purpur-${toKebabCase(key)}`,
            value
          );
        }
      );
    }
  }, [theme, cssVariablesSelector, currentColorScheme]);
};
